module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-4-en-US-172b501939fd4446d780748782f3d7ad.png";